import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { SaveApplicationEventMutation,  IApplicationEventInput } from '@ebb-v2/ebb-integration';

import { Apollo} from 'apollo-angular';

import { ApplicationEventApiService } from '../application-event-api.service';

@Injectable({
    providedIn: 'root'
  })
  export class ApplicationEventGqlService implements ApplicationEventApiService {


    constructor(
      private apollo: Apollo
    ) { }
  
  
    public updateApplicationEvent(applicationEvent: IApplicationEventInput): Observable<any> {
      //console.log(`ApplicationEventApi.updateApplication()`);
      return this.apollo
        .mutate({
          mutation: SaveApplicationEventMutation,
          variables : {
            applicationEvent
          }
        })
        .pipe(map(result => result.data['saveApplicationEvent'].id as string));
    }

  }